import React, { useState } from "react";
import { images } from "../../constant";

import { HiMenuAlt4, HiX } from "react-icons/hi";

import { motion } from "framer-motion";
import CV from "../../assets/Pujon Das Auvi_Full Stack Developer .pdf";
import "./Navbar.scss";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.Logo1} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "projects", "skills", "contact"].map((item) => (
          <li key={`link-${item}`} className="app__flex p-text">
            <div></div>
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>
      <button className="button">
        <a href={"https://drive.google.com/file/d/1e-z6sr-J5KuxhWfvcSOjgtIb0TuIdlE2/view?usp=sharing"} target="_blank" rel="noreferrer">
          Resume
        </a>
      </button>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [200, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <HiX onClick={() => setToggle(false)} />

            <ul>
              {["home", "about", "projects", "skills", "contact"].map(
                (item) => (
                  <li key={item} className="app__flex p-text">
                    <a href={`#${item}`} onClick={() => setToggle(false)}>
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
